import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { OrionProvider } from "./contexts/OrionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <OrionProvider>
            <App />
        </OrionProvider>
    </BrowserRouter>
);
